import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "rsuite/esm/DatePicker";
import { apiRequest } from "../../utils/utils";
import { toast } from "react-toastify";

const ExtendedFreeTrial = (props) => {
  
  const { data } = props;
  const [newFreeTrialDate, setNewFreeTrialDate] = useState("");

  const handleNewFreeTrailDateChange = (evt) => {
    const newdate = new Date(evt);
    newdate.setDate(newdate.getDate() + 1);
    const datenew = newdate.toISOString().split("T")[0];
    setNewFreeTrialDate(datenew);
  };

  useEffect(() => {
    if (data.free_trial_expiry_date) {
      const timestamp = data.free_trial_expiry_date;
      const date = new Date(timestamp * 1000).toISOString();
      setNewFreeTrialDate(date);
    }
  }, [data.free_trial_expiry_date]);

  const extendSubmit = async () => {
    let requestData = {
      app_token: data.customer_id,
      is_live: false,
      new_free_trial_date: new Date(newFreeTrialDate),
      product_key: data.product_key,
      store_key: data && data.store_key,
      user_uuid: data.customer_user_uuid,
    };
    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/muvi6/extend-free-trial`,
      "POST",
      requestData
    );

    if (responseData.code === 200) {
      toast.success("Free trial has been extended", {
        id: 1,
        position: "top-right",
      });
      props.close();
    } else {
      toast.error(responseData.message, { id: 1, position: "top-right" });
    }

    props.syncFilterWithAggrid();
  };
  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div class="form-group">
            <label for="recipient-name" className="control-label">
              Company
            </label>
            <input
              type="text"
              className="form-control"
              disabled
              value={data && data.company_name}
            />
          </div>
          <div class="form-group">
            <label for="recipient-name" className="control-label">
              Extend Till Date
            </label>
            <DatePicker
              oneTap
              block={true}
              value={new Date(newFreeTrialDate)}
              onChange={handleNewFreeTrailDateChange}
            />
            {/* <DatePicker
									selected={newFreeTrialDate}
									dateFormat="dd-MM-yyyy" // You can set the date format here
									placeholderText="Select date"
									onChange={handleNewFreeTrailDateChange}
									minDate={new Date()}
									yearDropdownItemNumber={15}
									block={true}
								/> */}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="dark"
            className="btn-dark-btn"
            onClick={props.close}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => extendSubmit()}
          >
            Submit
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ExtendedFreeTrial;



// WEBPACK FOOTER //
// ./src/components/childcomponents/ExtendedFreeTrial.js